import { ReactComponent as Logo } from "@brand_assets/svg/main-logo.svg"
import { ReactComponent as IconArrowSide } from "@common_assets/svg/arrow-side.svg"
import { IconButton, Stack } from "@mui/material"
import IconWrapper from "components/common/icon/iconWrapper"
import { useAppDispatch, useAppSelector } from "hooks/store"
import mixpanel from "mixpanel-browser"
import { useTranslation } from "react-i18next"
import { NavLink } from "react-router-dom"
import { RoutePath } from "routes/Route.types"
import { toggleIsMenuOpened } from "store/menu/menu.slice"
import { UserRole } from "ts/enums/User"
import { getAuthDataLocalStorage } from "utils/authData"

const NavHeader = () => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const isMenuOpened = useAppSelector((state) => state.menu.isMenuOpened)

  const toggleMenu = () => {
    if (getAuthDataLocalStorage()?.role === UserRole.TEACHER) {
      mixpanel.track("side_bar", {
        action: "close",
      })
    }
    dispatch(toggleIsMenuOpened())
  }

  return (
    <Stack
      mb="16px"
      direction="row"
      justifyContent="space-between"
      alignItems="center"
    >
      <NavLink to={RoutePath.HOMEPAGE} aria-label={t("layout.classBankLogo")}>
        <Logo />
      </NavLink>
      {getAuthDataLocalStorage()?.role === UserRole.TEACHER && (
        <IconButton
          aria-label={isMenuOpened ? t("layout.closeMenu") : t("layout.openMenu")}
          aria-expanded={isMenuOpened}
          sx={{ p: 0 }}
          onClick={toggleMenu}
        >
          <IconWrapper color="mockup.neutral100">
            <IconArrowSide />
          </IconWrapper>
        </IconButton>
      )}
    </Stack>
  )
}

export default NavHeader
